/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Constants, Language } from '../../global/constants';
import { ErrorService } from '../../services/error.service';
import { AdminSpamClassifierService } from '../../services/admin/admin-spamclassifier.service';
import { GlobalMessageService } from '../../services/global-message.service';
import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-admin-spam-classifier',
  templateUrl: './admin-spam-classifier.component.html'
})
export class AdminSpamClassifierComponent implements OnInit {
  loadingPage: boolean = true;
  editTrainingDialogRef: BsModalRef;
  showWordMap: boolean = false;
  currentTab: string = 'body';
  types = [
    {
      type: 'spam',
      display: 'Spam'
    },
    {
      type:'ham',
      display: 'Ham'
    }
  ];

  currentType: any;
  training: any[] = [];
  currentTraining: any;

  constructor(private errorService: ErrorService,
              private modalService: BsModalService,
              private adminSpamClassifierService: AdminSpamClassifierService,
              private constants: Constants,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    this.currentType = this.types[0];
    this.refreshTraining();
  }

  changeType(type: any) {
    this.currentType = type;
    this.refreshTraining();
  }

  editTraining(dialog, training: any) {
    this.currentTraining = training ? training : { content: '', language: 'en' };
    this.editTrainingDialogRef = this.modalService.show(dialog, {class: 'modal-md'});
  }

  saveTraining() {
    this.editTrainingDialogRef.hide();
    if (this.currentTraining._id) {
      this.adminSpamClassifierService.updateSpamTraining(this.currentTraining._id, this.currentTab, this.currentTraining.content, this.currentTraining.language).subscribe(
        (result: any) => {
          this.globalMessageService.message('Updated training');
          this.refreshTraining();
        },
        error => {
          this.globalMessageService.error();
          this.errorService.log(error, 'admin-nb-classifier.component', 'editTraining.100');
        }
      )
    }
    else {
      let model = {
        category: this.currentType.type,
        content: this.currentTraining.content,
        language: this.currentTraining.language,
        active: true
      };

      this.adminSpamClassifierService.newSpamTraining(this.currentTab, model).subscribe(
        (result: any) => {
          this.globalMessageService.message('Added training');
          this.refreshTraining();
        },
        error => {
          this.globalMessageService.error();
          this.errorService.log(error, 'admin-nb-classifier.component', 'editTraining.200');
        }
      )
    }
  }

  delete(training: any) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Confirm you'd like to delete this training: "${training.content}"`,
        confirm: function() {
          me.adminSpamClassifierService.deleteSpamTraining(training._id, me.currentTab).subscribe(
            (result: any) => {
              me.globalMessageService.message('Training was deleted');
              me.refreshTraining();
            },
            error => {
              me.globalMessageService.error();
              me.errorService.log(error, 'admin-nb-classifier.component', 'delete');
            });
        }
      }
    }));
  }

  clean() {
    this.currentTraining.content = this.currentTraining.content
                                  .replace(/['’]/g, '')
                                  .replace(/[@.,-\/#!?$%\^&\*;:{}=\-_`~()\<\>"|0-9]/g, ' ')
                                  .replace(/\s{2,}/g, ' ')
                                  .trim()
                                  .toLowerCase();
  }
  private refreshTraining() {
    this.loadingPage = true;
    //this.topWord = 0;
    //this.topStopword = 0;
    Observable.forkJoin(
      this.adminSpamClassifierService.getSpamTraining(this.currentTab, this.currentType.type),
      //this.classifierService.getWordmap(this.currentType.typeName)
    ).subscribe(
      (result: any) => {
        this.training = result[0];
        // this.wordmap = JSON.parse(result[1]);
        // this.wordmap.words.forEach((wm) => {
        //   if (wm.stop_word && wm.count > this.topStopword) {
        //     this.topStopword = wm.count;
        //   }
        //   else if (!wm.stop_word && wm.count > this.topWord) {
        //     this.topWord = wm.count;
        //   }
        // });
        this.loadingPage = false;
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'admin-spam-classifier.component', 'refreshTraining.100');
      }
    )
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin-spam-classifier/admin-spam-classifier.component.ts